<div class="eg-modal-overlay" (click)="onCancel()">
  <div class="eg-modal" (click)="$event.stopPropagation()">
    <header class="eg-head">
      <div class="eg-head-titleblock">
        <h2 class="eg-title">Manage entrance groups</h2>
        <p class="eg-sub">Drag entrances into a group to display them as a single summed tile. Ungrouped entrances remain individual.</p>
      </div>
      <button type="button" class="eg-close" (click)="onCancel()" aria-label="Close">✕</button>
    </header>

    <div class="eg-body">
      <div class="eg-toolbar">
        <button type="button" class="eg-add-btn" (click)="addGroup()">+ New group</button>
        <span class="eg-toolbar-meta">{{ groups.length }} group{{ groups.length === 1 ? '' : 's' }} · {{ entranceNames.length }} entrance{{ entranceNames.length === 1 ? '' : 's' }} total</span>
      </div>

      <div class="eg-columns">
        <div class="eg-col eg-col-ungrouped">
          <header class="eg-col-head">
            <span class="eg-col-title">Ungrouped entrances</span>
            <span class="eg-col-meta">{{ isFiltering ? filteredUngrouped.length + ' / ' + ungrouped.length : ungrouped.length }}</span>
          </header>
          <div class="eg-filter-row">
            <input type="text"
                   class="eg-filter-input"
                   placeholder="Filter entrances…"
                   [(ngModel)]="ungroupedFilter"
                   (ngModelChange)="applyFilter()" />
            <button type="button"
                    class="eg-filter-clear"
                    *ngIf="isFiltering"
                    (click)="clearFilter()"
                    aria-label="Clear filter">✕</button>
          </div>
          <div class="eg-droplist"
               cdkDropList
               id="eg-ungrouped"
               [cdkDropListData]="filteredUngrouped"
               [cdkDropListConnectedTo]="groupListIds()"
               (cdkDropListDropped)="onDrop($event)">
            <div class="eg-entrance-chip"
                 *ngFor="let entrance of filteredUngrouped; trackBy: trackEntrance"
                 cdkDrag
                 [cdkDragData]="entrance">
              <span class="eg-entrance-handle" aria-hidden="true">⋮⋮</span>
              <span class="eg-entrance-name">{{ entrance }}</span>
            </div>
            <div class="eg-empty" *ngIf="!filteredUngrouped.length && isFiltering">No entrances match “{{ ungroupedFilter }}”</div>
            <div class="eg-empty" *ngIf="!ungrouped.length && !isFiltering">All entrances are grouped</div>
          </div>
        </div>

        <div class="eg-groups-col">
          <div class="eg-col eg-col-group"
               *ngFor="let group of groups; trackBy: trackGroup">
            <header class="eg-col-head">
              <input type="text"
                     class="eg-group-name-input"
                     [class.input-error]="group.nameError"
                     placeholder="Group name (e.g. North Stand)"
                     [(ngModel)]="group.name" />
              <span class="eg-col-meta">{{ group.entranceNames.length }}</span>
              <button type="button"
                      class="eg-group-add-filtered"
                      *ngIf="isFiltering && filteredUngrouped.length"
                      [appTooltip]="'Add the ' + filteredUngrouped.length + ' filtered entrance' + (filteredUngrouped.length === 1 ? '' : 's') + ' to this group'"
                      (click)="addFilteredToGroup(group)">+ {{ filteredUngrouped.length }}</button>
              <button type="button"
                      class="eg-group-delete"
                      appTooltip="Delete group (entrances return to ungrouped)"
                      (click)="removeGroup(group)">✕</button>
            </header>
            <div class="eg-droplist"
                 cdkDropList
                 [id]="group.id"
                 [cdkDropListData]="group.entranceNames"
                 [cdkDropListConnectedTo]="['eg-ungrouped'].concat(groupListIds())"
                 (cdkDropListDropped)="onDrop($event)">
              <div class="eg-entrance-chip"
                   *ngFor="let entrance of group.entranceNames; trackBy: trackEntrance"
                   cdkDrag
                   [cdkDragData]="entrance">
                <span class="eg-entrance-handle" aria-hidden="true">⋮⋮</span>
                <span class="eg-entrance-name">{{ entrance }}</span>
              </div>
              <div class="eg-empty" *ngIf="!group.entranceNames.length">Drag entrances here</div>
            </div>
          </div>

          <button type="button"
                  class="eg-add-group-card"
                  *ngIf="!groups.length"
                  (click)="addGroup()">
            <span class="eg-add-icon">+</span>
            <span>Create your first group</span>
          </button>
        </div>
      </div>
    </div>

    <footer class="eg-foot">
      <div class="eg-foot-actions">
        <button type="button"
                class="eg-btn eg-btn-cancel"
                (click)="onCancel()">Cancel</button>
        <button type="button"
                class="eg-btn eg-btn-save"
                (click)="onSave()">Save groups</button>
      </div>
    </footer>
  </div>
</div>
